import {
  CollectionStatus,
  submitWay,
  subState,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

const searchFormList: any = [
  {
    label: "申請方式",
    keyword: "corpApplyKbn",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(submitWay),
  },
  {
    label: "提出状況",
    keyword: "lastApplyStatus",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(subState),
  },
  {
    label: "納付状況",
    keyword: "receiveStatus",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(CollectionStatus),
  },
  {
    label: "割増金納付状況",
    keyword: "surchargeReceiveStatus",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(CollectionStatus),
  },
];

const infoHeadTitleList: any[] = [
  { headTitle: "契約者名" },
  { headTitle: "申請方法" },
  { headTitle: "掛金届" },
  { headTitle: "掛金" },
  { headTitle: "納付状況" },
  { headTitle: "督促回数" },
  { headTitle: "割増金請求額" },
  { headTitle: "割増金納付状況" },
];

export { searchFormList, infoHeadTitleList };
